import clientsApi from '@/api/v1/clients';
import developerApi from '@/api/v1/developer';
import assign from 'lodash/assign';

export default {
  namespaced: true,

  state: {
    developer: {
      personal_data: {
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        city: '',
        nationality: '',
        phone_number: '',
        birthdate: '',
        level: '',
        experience_in_years: '',
        is_verified: false,
        linkedin_link: '',
        git_link: '',
        skype_link: '',
        status: '',
        software_house: {
          name: '',
          pm_first_name: '',
          pm_last_name: '',
          pm_email: '',
          pm_phone_number: '',
        },
      },
      availability: {
        status: '',
        from: '',
        to: '',
      },
      finance: {
        contract_types: [],
        currency: '',
        rate: '',
        working_hours: [],
      },
      basic_data_filled: true,
      attachments: [],
      roles: [],
      top_skills: [],
      skills: [],
      languages: [],
      tools: [],
      management: [],
      technologies: [],
      project_areas: [],
      soft_skills: {},
      hobbies: [],
      education: [],
      experience: [],
      description: '',
      recommendation: '',
      notes: '',
      profile_progress: {
        level: '',
        label: '',
      },
    },

    isDataLoading: false,
  },

  mutations: {
    CHANGE_DEVELOPER(state, developerData) {
      state.developer = assign(state.developer, developerData);
    },

    CHANGE_SCORE(state, score) {
      state.score = score;
    },

    CHANGE_LOADING_STATUS(state, status) {
      state.isDataLoading = status;
    },
  },

  actions: {
    fetchDeveloper({ commit }, developerId) {
      commit('CHANGE_LOADING_STATUS', true);

      return new Promise((resolve, reject) => {
        clientsApi.developers
          .show(developerId)
          .then((resp) => {
            commit('CHANGE_DEVELOPER', resp.data);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            commit('CHANGE_LOADING_STATUS', false);
          });
      });
    },

    generateDeveloperCv({ dispatch }, developerId) {
      return new Promise((resolve, reject) => {
        clientsApi.developers
          .cv(developerId)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },

    addDeveloperData({ commit }, developerData) {
      commit('CHANGE_DEVELOPER', developerData);
    },

    updateDeveloper({ dispatch, commit }, developerData) {
      return new Promise((resolve, reject) => {
        developerApi.accounts
          .updateDeveloper(developerData)
          .then((resp) => {
            commit('CHANGE_DEVELOPER', resp.data);
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },

    submitDeveloperSurvey({ dispatch, commit, rootState }) {
      return new Promise((resolve, reject) => {
        developerApi.accounts
          .developerSoftSkills({
            answers: rootState.survey.answers,
          })
          .then((resp) => {
            commit('CHANGE_DEVELOPER', resp.data);
            dispatch('showSuccess', ['Survey submitted'], { root: true });
            resolve();
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },
  },
};
